import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDimensionTeam state domain
 */

const selectWidgetResultByDimensionTeamDomain = (state) =>
  state.get("widgetResultByDimensionTeam", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionTeamDomain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionTeamDomain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectTeams = () =>
  createSelector(selectWidgetResultByDimensionTeamDomain, (state) =>
    state.get("teams")
  )

/**
 * Default selector used by WidgetResultByDimensionTeam
 */

const makeSelectWidgetResultByDimensionTeam = () =>
  createSelector(selectWidgetResultByDimensionTeamDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimensionTeam
export { selectWidgetResultByDimensionTeamDomain }
